// tslint:disable
export function getCookie(name) {
  let value = '; ' + document.cookie;
  let parts = value.split('; ' + name + '=');
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

// TODO include a step in webpack that sets this variable.
// Set to 'production' to hit actual backend.
const ENV = 'production';

export function getUrl(): string {
  switch (getEnvironment()) {
    case 'LOCAL': return 'http://localhost:2586';
    case 'DEV': return 'https://clpbp-public-dev.loandepotdev.works';
    case 'DV1': return 'https://clpbp-public-dv1.loandepotdev.works';
    case 'QA': return 'https://clpbp-public-qa.loandepotdev.works';
    case 'QA1': return 'https://clpbp-public-qa1.loandepotdev.works';
    case 'STG': return 'https://clpbp-public-stg.loandepotdev.works';
    case 'SG1': return 'https://clpbp-public-sg1.loandepotdev.works';
    case 'PERF': return 'https://clpbp-public-perf.loandepotdev.works';
    case 'TN1': return 'https://clpbp-public-tn1.loandepotdev.works';
    case 'DEM': return 'https://clpbp-public-dem.loandepotdev.works';
    case 'RPRD':
    default: return 'https://clpbpapi.myloandepot.com';
  }
}

type Environment = 'LOCAL'|'DEV'|'DV1'|'QA'|'QA1'|'STG'|'SG1'|'PERF'|'TN1'|'DEM'|'RPRD';

export function getEnvironment(): Environment {
  const appUrl = window.location.hostname;
  if (appUrl.indexOf('-dev.') > -1) {
    return 'DEV';
  } else if (appUrl.indexOf('-dv1.') > -1) {
    return 'DV1';
  } else if (appUrl.indexOf('-qa.') > -1) {
    return 'QA';
  } else if (appUrl.indexOf('-qa1.') > -1) {
    return 'QA1';
  } else if (appUrl.indexOf('-stg.') > -1) {
    return 'STG';
  } else if (appUrl.indexOf('-sg1.') > -1) {
    return 'SG1';
  } else if (appUrl.indexOf('-perf.') > -1) {
    return 'PERF';
  } else if (appUrl.indexOf('-tn1.') > - 1) {
    return 'TN1';
  } else if (appUrl.indexOf('-dem.') > - 1) {
    return 'DEM';
  } else if (appUrl.indexOf('localhost') > -1) {
    return 'LOCAL';
  } else {
    return 'RPRD';
  }
}

(function setupFirefly() {
  const token = '555a4e0ee81211ec0b5b750d';
  let assetHostUrl;
  let serverHostUrl;
  let scriptSource;

  // CLPBP-88 - For now, point to PROD to be in sync with CLPCore in all environments
  // Eventually we want to point to UAT for non-prod environments
  // if (getEnvironment() === 'PROD') {
    assetHostUrl = 'https://firefly-071591.s3.amazonaws.com';
    serverHostUrl = 'https://usefirefly.com:443';
    scriptSource = 'https://firefly-071591.s3.amazonaws.com/scripts/loaders/loader.js';
  // } else {
  //   assetHostUrl = 'https://firefly-us-uat.s3.amazonaws.com';
  //   serverHostUrl = 'https://uat.usefirefly.com';
  //   scriptSource = 'https://firefly-us-uat.s3.amazonaws.com/scripts/loaders/loader.js';
  // }

  window['fireflyAPI'] = {};
  window['fireflyAPI'].ready = function (x) {
    if (typeof x == 'function') {
      x = [x];
    }
    window['fireflyAPI'].onLoaded = window['fireflyAPI'].onLoaded || [];
    for (let i = 0; i < x.length; i++) {
      if (window['fireflyAPI'].isLoaded) {
        x[i]();
      } else {
        window['fireflyAPI'].onLoaded.push(x[i]);
      }
    }
  };
  window['fireflyAPI'].token = token;
  window['fireflyAPI'].assetHostUrl = assetHostUrl;
  window['fireflyAPI'].serverHostUrl = serverHostUrl;
  window['fireflyAPI'].publishSettingsToS3 = true;
  window['fireflyAPI'].publishStaticContentToS3 = true;
  window['fireflyAPI'].s3HostUrl = 'https://firefly-071591.s3.amazonaws.com';
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = scriptSource;
  script.async = true;
  let firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
})();

// Route path segment names
const APP_BASE: string = '/';
const APP_BASE_TRIMMED = (

  // If APP_BASE has a slash at the end & is not an empty string...
  (APP_BASE.lastIndexOf('/') >= APP_BASE.length - 1)

  // Remove the slash.
  ? APP_BASE.slice(0, -1)

  // Otherwise do nothing - we don't want the slash in this bucket (APP_BASE_TRIMMED.)
  : APP_BASE
);
const MORTGAGE_BASE: string = 'mortgage';
const PL_BASE: string = 'personal-loans';

// The suffix (APP_BASE_SUFFIX) is the connection string between the APP_BASE & the next segment.
// Contains empty value or a single slash, as appropriate.
const APP_BASE_SUFFIX = (!APP_BASE_TRIMMED ? '' : '/');

// The APP_BASE_TRIMMED is an empty string, APP_BASE_SLASH will not have a trailing slash (the browser will handle it.)
// Otherwise, there will be a trailing slash (ex. '' vs. 'mortgage/') - both ready for the next segment.
const APP_BASE_SLASH = APP_BASE_TRIMMED + APP_BASE_SUFFIX;
const DASHBOARD_BASE: string = 'dashboard';
const LOGIN_BASE: string = 'login';
const SIGNIN_BASE: string = 'sign-in';

// IOvation settings
const IOVATION_SNARE_JS_TEST = 'https://ci-mpsnare.iovation.com/snare.js';
const IOVATION_SNARE_JS_PROD = 'https://mpsnare.iesnare.com/snare.js';

export const GOOGLE_MAPS_API_KEY = 'AIzaSyApgRdfgDSoWyq_Jgk4waCTyVjDTBBtgq0';
export const ROUTES = {
  APP_BASE: APP_BASE_TRIMMED,

  // Use this as follows (with prefixed slash if root/absolute-path is needed)...
  // `/${ SETTINGS.ROUTES.APP_BASE_SLASH }next-segment-goes-here`
  APP_BASE_SLASH: APP_BASE_SLASH,
  MORTGAGE_BASE: MORTGAGE_BASE,
  MORTGAGE_FULL: APP_BASE_SLASH + MORTGAGE_BASE,
  MORTGAGE_PAYMENT: 'https://www.loandepot.com/about/loan-servicing',
  PL_BASE: PL_BASE,
  PL_FULL: APP_BASE_SLASH + PL_BASE,

  // TODO: when we go to production, change to: 'https://www.payment.loandepot.com'
  PL_PAYMENT: 'https://payment.loandepot.com',
  DASHBOARD_BASE: DASHBOARD_BASE,
  DASHBOARD_FULL: APP_BASE_SLASH + DASHBOARD_BASE,
  LOGIN_BASE: LOGIN_BASE,
  LOGIN_FULL: APP_BASE_SLASH + LOGIN_BASE,
  SIGNIN_BASE: SIGNIN_BASE,
  SIGNIN_FULL: APP_BASE_SLASH + SIGNIN_BASE
};

export const SETTINGS = {
  API: {
    ENV: getEnvironment(),
    URL: getUrl(),
    NAME_SPACE: 'api/v1'
  },
  GOOGLE_MAPS_STYLES: [
    { featureType: 'road', stylers: [{ hue: '#5e00ff' }, { saturation: -79 }] },
    { featureType: 'poi', stylers: [{ saturation: -78 }, { hue: '#6600ff' }, { lightness: 50 }] },
    { featureType: 'landscape', stylers: [{ hue: '#6600ff' }, { saturation: -11 }] },
    { featureType: 'water', stylers: [{ saturation: -65 }, { hue: '#1900ff' }, { lightness: 8 }] },
    { featureType: 'road.local', stylers: [{ lightness: 22 }, { weight: 1.3 }, { lightness: 30 }] },
    { featureType: 'transit', stylers: [{ visibility: 'simplified' }, { hue: '#5e00ff' }, { saturation: -16 }] },
    { featureType: 'transit.line', stylers: [{ saturation: -72 }] }
  ],
  IOVATION_SNARE_JS: IOVATION_SNARE_JS_TEST,
  // To enabled mock backend or dev routing, set the environment to something other than production
  // and type 'document.cookie="mock=true"' or 'document.cookie="dev-routing=true"' in your browser console.
  IS_MOCK_ENABLED: ('production' !== ENV) && !!getCookie('mock'),
  DEV_ROUTING: ('production' !== ENV) && !!getCookie('dev-routing')
};
